import { message } from "antd";
import { makeAutoObservable } from "mobx";
import { getLocalStorage, LOCAL_STORAGE_TYPE, setLocalStorage } from "../../common/localStorage";
import { createAdvertiser, deleteAdvertiser, getAdvertiserList, updateAdvertiser } from "../../apis/retailMediaApi";
import { globalStores } from "../../GlobalStores";

class AdAccountStores {
  currentAcc = undefined;
  advertisers = [];
  loading = false;

  //Pageable informations
  limit = 3000;
  offset = 0;
  page = 1;
  totalPages = 1;
  totalElements = 0;
  last = false;
  //End Pagable informations

  textSearch = "";

  constructor() {
    makeAutoObservable(this);
  }

  setPageable(pageable) {
    this.page = pageable.page;
    this.totalPages = pageable.totalPages;
    this.totalElements = pageable.totalElements;
    this.last = pageable.last;
  }

  onPaginationChange(page, pageSize) {
    this.page = page;
    this.limit = pageSize;
    const offset = (page - 1) * pageSize;
    this.offset = offset;
    this.getAdvertisers(offset);
  }

  setTextSearch(data) {
    this.textSearch = data;
  }

  setCurrentAcc(data) {
    this.currentAcc = data;
    setLocalStorage(LOCAL_STORAGE_TYPE.CURRENT_AD_ACCOUNT, data.id);
  }

  async getAdvertisers(offset = this.offset) {
    try {
      this.loading = true;
      const { dataArray, pageable } = await getAdvertiserList(this.limit, offset, this.textSearch);
      this.advertisers = dataArray || [];
      this.setPageable(pageable);
      if (dataArray?.length) {
        const curAccId = getLocalStorage(LOCAL_STORAGE_TYPE.CURRENT_AD_ACCOUNT);
        const curAcc = dataArray.find((item) => item.id === curAccId);
        this.setCurrentAcc(curAcc || dataArray[0]);
      }
    } catch {
      message.error(globalStores.t("An error occurred while retrieving data"));
    } finally {
      this.loading = false;
    }
  }

  async saveAdvertiser(payload, id) {
    try {
      this.loading = true;
      if (id) {
        await updateAdvertiser(payload, id);
      } else {
        await createAdvertiser(payload);
      }
      await this.getAdvertisers();
    } catch (error) {
      message.error(globalStores.t("Failed"));
    } finally {
      this.loading = false;
    }
  }

  async deleteAdvertiser(id) {
    try {
      this.loading = true;
      await deleteAdvertiser(id);
      message.success(globalStores.t("Successfully"));
      await this.getAdvertisers();
    } catch (error) {
      message.error(globalStores.t("Failed"));
    } finally {
      this.loading = false;
    }
  }
}

export const adAccountStores = new AdAccountStores();
